import { FEATURES } from 'tenant/config';

// WARNING: we need to add only ONE corridor here
// Otherwise it will appear repeated in the screens
const enabledCorridors = ['BCN-MAD'];

const getSimpleName = (route, local, name, isLhFilterEnabled) => {
  if (isLhFilterEnabled) {
    return local ? route.origin : name;
  }
  return route.origin === route.destination ? route.origin : name;
};

export const mapRoute = (enabled) => (route) => {
  const isLhFilterEnabled = FEATURES.IS_LH_FILTER_ENABLED;
  const local = isLhFilterEnabled ? route.origin === route.destination : true;
  const name = `${route.origin}-${route.destination}`;
  const reverse = `${route.destination}-${route.origin}`;
  const alphabeticalOrder = route.origin < route.destination;
  const symmetric_name = local
    ? name
    : alphabeticalOrder
    ? `${name},${reverse}`
    : `${reverse},${name}`;
  const simple_name = getSimpleName(route, local, name, isLhFilterEnabled);

  return {
    ...route,
    enabled,
    local,
    defined: route.origin !== 'OTH' && route.destination !== 'OTH',
    name,
    isInternational: route.country === 'EU',
    simple_name: simple_name,
    symmetric_name,
    enabled_corridor: enabledCorridors.includes(name),
  };
};

export function routes(state = [], action) {
  switch (action.type) {
    case 'LOAD_ROUTES_REQUEST':
    case 'LOAD_ROUTES_ERROR':
      return [];
    case 'LOAD_ROUTES_DONE':
      return [...action.enabled.map(mapRoute(true)), ...action.disabled.map(mapRoute(false))];
    default:
      return state;
  }
}
